import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const ArrowRightIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon height="20" viewBox="0 0 20 20" width="20" {...props}>
      <path
        clipRule="evenodd"
        d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM6 9H10V6L14 10L10 14V11H6V9Z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
